import { useEffect, useState } from "react";
import { WelcomePageWrapper, AlignWrapper, Align } from "./style";
import LoginStepFour from "components/LoginStepFour";


const LoginPageFour = () => {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [])

  if (loading) return null

  return (
    <>
      <div className="sixmeetings-content">
        <div className="sixmeetings-adss">
          <WelcomePageWrapper>
            <AlignWrapper>
              <Align>
                <LoginStepFour />
              </Align>
            </AlignWrapper>
          </WelcomePageWrapper>
        </div>
      </div>
    </>
  );
};
export default LoginPageFour;